// "Kütüphaneden seç" for the add-logo popup: the organization's brand-library
// logos (Marka kütüphanesi → Logolar), listed in place inside the popup — no
// popup over the popup. Picking one hands its url to onPick, the same field an
// uploaded logo fills (config.referenceImageUrl → body.logoUrl).

import { useState } from "react";
import i18n from "i18next";
import { LuBadgeCheck, LuLoaderCircle } from "react-icons/lu";
import { getBrandKit } from "../../../services/brandKitService";

// The main logo first, then the library's own order.
const logosOf = (kit) =>
  ((kit && kit.assets && kit.assets.logo) || [])
    .filter((a) => a && a.url)
    .sort((a, b) => Number(!!b.isPrimary) - Number(!!a.isPrimary));

export default function BrandLogoPicker({ onPick }) {
  const [open, setOpen] = useState(false);
  // null until loaded; a failed load stays null so the next open retries.
  const [logos, setLogos] = useState(null);
  const [error, setError] = useState(null);

  const toggle = () => {
    if (open) return setOpen(false);
    setOpen(true);
    if (logos) return;
    setError(null);
    getBrandKit()
      .then((kit) => setLogos(logosOf(kit)))
      .catch((e) => setError(e?.message || i18n.t("AreaOps.LibraryLoadFailed")));
  };

  const renderBody = () => {
    if (error) return <div className="aops-error">{error}</div>;
    if (!logos) {
      return (
        <div className="aops-lib-state">
          <LuLoaderCircle size={14} className="aops-spin" />
        </div>
      );
    }
    if (!logos.length) {
      return <div className="aops-lib-state">{i18n.t("AreaOps.LibraryNoLogos")}</div>;
    }
    return (
      <div className="aops-lib-grid">
        {logos.map((asset) => (
          <button
            key={asset.id}
            type="button"
            className="aops-lib-item"
            title={asset.name}
            onClick={() => onPick(asset.url)}
          >
            <img src={asset.url} alt={asset.name} draggable={false} />
          </button>
        ))}
      </div>
    );
  };

  return (
    <>
      <button
        type="button"
        className={`aops-upload aops-upload--library ${open ? "is-open" : ""}`}
        aria-expanded={open}
        onClick={toggle}
      >
        <LuBadgeCheck size={14} />
        <span>{i18n.t("AreaOps.PickFromLibrary")}</span>
      </button>
      {open && <div className="aops-lib">{renderBody()}</div>}
    </>
  );
}
